export const STANDARD_THEME = "standard";
export const LIGHT_THEME = "light";
export const DARK_THEME = "dark";
export const SNOW_THEME = "snow";
export const CLASSIC_THEME = "classic";

export const STANDARD_STANDARD_TILESET = "standard";
export const LIGHT_LIGHT_TILESET = "light";
export const DARK_DARK_TILESET = "dark";
export const SNOW_SNOW_TILESET = "snow";
export const SNOW_CHRISTMAS_TILESET = "christmas";
export const CLASSIC_MODERN_TILESET = "modern";
export const CLASSIC_CLASSIC_TILESET = "classic";
export const CLASSIC_COLORFUL_TILESET = "colorful";
export const CLASSIC_INITIAL_COMMIT_TILESET = "initial-commit";

export const STANDARD_BLOCK_STYLE = "standard";
export const COMPACT_BLOCK_STYLE = "compact";

export const THEME_PREFERENCE_NAME = "theme";
export const TILESET_PREFERENCE_NAME = "tileset";
export const ANIMATIONS_PREFERENCE_NAME = "animations";
export const BLOCK_STYLE_PREFERENCE_NAME = "block";
export const DEBUG_HUD_ENABLED_PREFERENCE_NAME = "debugHudEnabled";
export const DEBUG_HUD_VISIBLE_PREFERENCE_NAME = "debugHudVisible";
export const FULLSCREEN_PREFERENCE_NAME = "fullscreen";

export const THEME_SETTING_NAME = "theme-switch";
export const TILESET_SETTING_NAME = "tileset-switch";
export const ANIMATIONS_SETTING_NAME = "animations";
export const BLOCK_STYLE_SETTING_NAME = "block";
export const FULLSCREEN_SETTING_NAME = "fullscreen";
export const CLEAR_DATA_SETTING_NAME = "clear-all-data";

export const SETTING_ENABLED = "enabled";
export const SETTING_DISABLED = "disabled";

export const LANDSCAPE_CLASS_NAME = "landscape";

export const CLASSIC_THEME_LABEL = "2048Clone";
